import {Menu, MenuButton, MenuItems, MenuItem} from '@headlessui/react';
import {ChevronDownIcon} from '@heroicons/react/20/solid';
import {MENU_CONFIG, MENU_ITEM_CONFIG} from './styles';
import {classNames} from './util';
import {useEffect, useState} from 'react';

export interface DropMenuItem {
  value: string;
  callback: () => void;
}

interface DropMenuProps {
  label: string;
  items: DropMenuItem[];
  style: string;
  initialValue?: string;
  onClick?: () => void;
}

export function DropMenu({label, items, style, initialValue, onClick}: DropMenuProps) {
  const [currentValue, setCurrentValue] = useState(initialValue ?? '');

  function handleSelectItem(item: DropMenuItem) {
    setCurrentValue(item.value);
    item.callback();
  }

  useEffect(() => {
    const itemValues = items.map(item => item.value);

    if (!itemValues.includes(currentValue)) {
      setCurrentValue('');
    }
  }, [items]);

  return (
    <Menu as="div" className={MENU_CONFIG}>
      {() => (
        <div>
          <MenuButton className={style} onClick={onClick}>
            {label}
            <ChevronDownIcon className="w-4 ml-1" />
          </MenuButton>
          <MenuItems className={MENU_ITEM_CONFIG}>
            <div className="py-1">
              {items.map(item => (
                <MenuItem key={item.value}>
                  {({focus}) => (
                    <span
                      className={classNames(
                        focus ? 'bg-gray-200 text-gray-900' : 'text-gray-700',
                        'block px-4 py-2 text-sm cursor-pointer'
                      )}
                      onClick={() => handleSelectItem(item)}
                    >
                      {item.value === currentValue ? '* ' : null}
                      {item.value}
                    </span>
                  )}
                </MenuItem>
              ))}
            </div>
          </MenuItems>
        </div>
      )}
    </Menu>
  );
}
